import React, {
    useEffect,
    useState,
    useCallback,
    useContext,
    useMemo
} from 'react';
import _ from 'lodash';
import { logout, SgAccountDetails, CepConstants } from 'saga-cep-specific-components';
import { useSgTrackPageName, SgWebchatUtil } from 'saga-modules';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import { Loader, Link } from '@jutro/components';
import { UsersProfileDetailsService } from 'gw-capability-profileinfo';
import { TranslatorContext } from '@jutro/locale';

import SgCepSideMenu from 'sg-cep-side-menu';
import metadata from './AccountPage.metadata.json5';
import styles from './AccountPage.module.scss';
import messages from './AccountPage.messages';

function AccountPage() {
    const [isLoading, setLoadingState] = useState(true);
    const [accountDetails, setAccountDetails] = useState({});
    const translator = useContext(TranslatorContext);

    useSgTrackPageName(CepConstants.PAGE_NAMES.MY_ACCOUNT);

    useEffect(() => {
        UsersProfileDetailsService.getAccountContactSummaryExt().then((results) => {
            setAccountDetails(results);
            setLoadingState(false);
        });
    }, []);

    const trackChat = useCallback((event) => {
        if (event) {
            event.preventDefault();
        }
        SgWebchatUtil.trackChat();
    }, []);

    const ifYouArePolicyholderMessageContent = useMemo(() => {
        return (
            <>
                <span>{translator(messages.IfYouArePolicyholder)}</span>
                <Link
                    href="/"
                    id="webchatLink"
                    onClick={trackChat}
                    className="sgWebchatLink saga-intercom"
                    aria-hidden="true"
                >
                    {translator(messages.WebChatLink)}
                </Link>
            </>
        );
    }, [trackChat, translator]);

    const overrideProps = {
        accountDetailsComponent: {
            visible: !_.isEmpty(accountDetails),
            contactDetails: accountDetails.accountContact
        },
        noAccountContaier: {
            visible: _.isEmpty(accountDetails)
        },
        ifYouArePolicyholderMessage: {
            content: ifYouArePolicyholderMessageContent
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            SgAccountDetails,
            SgCepSideMenu
        },
        resolveCallbackMap: {
            onLogout: logout
        }
    };

    if (isLoading) {
        return <Loader loaded={!isLoading} />;
    }

    return renderContentFromMetadata(metadata.pageContent, overrideProps, resolvers);
}

export default AccountPage;
